<template>
    <div class="detail">
        <div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
                <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                <el-breadcrumb-item>detail</el-breadcrumb-item>
            </el-breadcrumb>
            <div id="slider-container">
                <div id="slider">
                    <div class="large-image-container">
                        <video controls v-if="selectedImage == 'mp4'" style="width: 100%; height:100%;" autoplay>
                            <source :src="this.images[this.selectedIndex1]" type="video/mp4">
                        </video>
                        <div v-if="selectedImage == 'image' && this.images.length > 0">
                            <div>
                                <div>
                                    <img v-lazy="this.images[this.selectedIndex1]" style="width: 100vw;height: 100vw;"
                                        alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="thumbnail-container">
                <div v-for="(image, index) in images" :key="index">
                    <div v-if="fileSubstr(image) == 'mp4'" :class="{ 'active': selectedIndex1 === index }"
                        @click="showLargeImage(index)" class="smallmp4">
                        <video style="width: 100% ; height:100%;object-fit: fill;border-radius: 10px;">
                            <source :src="image" type="video/mp4">
                        </video>
                        <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">
                            <img src="../assets/imgs/uploads/videoct.png" style="width: 17.6vw;height: 18.4vw;" alt="">
                        </div>
                    </div>
                    <img v-else v-lazy="image" @click="showLargeImage(index)"
                        :class="{ 'active': selectedIndex1 === index }" />
                </div>
            </div>
            <div style="padding: 0 7.467vw;">
                <button class="export" :disabled="isClick1" @click="downLoads()">
                    <img src="../assets/imgs/uploads/tabler_download.png" alt="" style="width: 3.2vw;height: 3.2vw;">
                    Marketing Kit</button>
                <div style="margin-bottom: 2.4vw;">
                    <img v-if="productDetail.brand == 'Gigwi'" src="../assets/imgs/uploads/Rectangle 139.png" alt=""
                        style="width: 18.667vw;height: 7.733vw;">
                    <img v-if="productDetail.brand == 'SKIPDAWG'" src="../assets/imgs/uploads/Rectangle 132.png" alt=""
                        style="width: 34.667vw;height: 7.733vw;">
                    <img v-if="productDetail.brand == 'PETGEEK'" src="../assets/imgs/uploads/Rectangle 131.png" alt=""
                        style="width: 34.667vw;height: 7.733vw;">
                    <img v-if="productDetail.brand == 'Gifts For Paws'" src="../assets/imgs/uploads/Rectangle 13.png" alt=""
                        style="width: 34.667vw;height: 7.733vw;">
                </div>
                <p style="font-size: 6.4vw; font-weight: bold;color: #000;">
                    {{ productDetail.spuName }}</p>
                <div style="margin-top: 4.8vw;font-size: 4.533vw;color: #959595;">OPTION ·
                    <span style="color: #545454;">{{ productSkuInfo.name }}</span>
                </div>
                <div class="checktab">
                    <div class="opn" v-for="(item, index) in models" :key="index" @click="selectOption(index)"
                        :class="{ 'selected': selectedIndex === index }">
                        <div style="display: flex; justify-content: center;"><img
                                style="width: 70px; height: 70px;border-radius: 5px;" v-lazy="item" alt=""></div>
                    </div>
                </div>
                <p style="color: #959595;font-size: 3.467vw;">Unit Price</p>
                <p style="color: #000;font-size: 4.533vw;">$ {{ unit }}</p>
                <el-divider></el-divider>
                <p style="color: #959595;font-size: 3.467vw;">Quanlity</p>
                <div style="margin-top: 5px;display: flex;justify-content: space-between;align-items: center;">
                    <div>
                        <el-input-number v-if="isLcl === 0" style="width: 44.267vw;" :step="amount" size="medium"
                            v-model="num" :min="0" :max="stockNum" step-strictly></el-input-number>
                        <el-input-number v-else style="width: 44.267vw;" size="medium" v-model="num"
                            :min="0" :max="stockNum"></el-input-number>
                    </div>
                    <div>
                        <p style="font-size: 3.2vw;color: #545454;">MOQ : {{ amount }} Piece</p>
                        <div class="status">{{ getLabelForStatus(stus) }}</div>
                    </div>
                </div>
                <p style="color: #959595;font-size: 3.467vw;margin-top: 4vw;">Subtotal</p>
                <div style="font-size: 5.6vw;font-weight: bold;color: #000;">${{ formatF((unit * 1000) * num / 1000) }}
                </div>
                <button :disabled="isClick" class="btn" @click="addCart()">
                    Add to Cart</button>
                <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 9.333vw;">
                    <div v-if="this.likeStatus === '0'">
                        <img :src="currentImage1" @click="likes" style="width: 16.267vw;height: 12.533vw;">
                        <img :src="currentImage2" @click="dislikes" style="width: 16.267vw;height: 12.533vw;">
                    </div>
                    <div v-if="this.likeStatus === '1'" style="display: flex;">
                        <div
                            style="width: 22.667vw;height: 12.533vw;border-radius: 6.667vw 0 0 6.667vw;background-color: #E4E4E4;display: flex;align-items: center;">
                            <img src="../assets/imgs/uploads/like.png" alt=""
                                style="width: 6.4vw;height: 6.4vw;margin-left: 5.067vw;">
                            <span style="color: #959595;font-weight: bold;margin-left: 3px;">{{ likNum }}</span>
                        </div>
                        <div
                            style="width: 22.667vw;height: 12.533vw;border-radius: 0 6.667vw 6.667vw 0;background-color: #E4E4E4;
                                                                                                        margin-left: 2px;display: flex;justify-content: flex-end;align-items: center;">
                            <span style="color: #959595;font-weight: bold;margin-left: 8px;">{{ dlikNum }}</span>
                            <img src="../assets/imgs/uploads/dislike1.png" alt=""
                                style="width: 6.4vw;height: 6.4vw;margin-left: 3px;margin-right: 5.067vw;">
                        </div>
                    </div>
                    <div v-if="this.likeStatus === '2'" style="display: flex;">
                        <div
                            style="width: 22.667vw;height: 12.533vw;border-radius: 6.667vw 0 0 6.667vw;background-color: #E4E4E4;display: flex;align-items: center;">
                            <img src="../assets/imgs/uploads/like1.png" alt=""
                                style="width: 6.4vw;height: 6.4vw;margin-left: 5.067vw;">
                            <span style="color: #959595;font-weight: bold;margin-left: 3px;">{{ likNum }}</span>
                        </div>
                        <div
                            style="width: 22.667vw;height: 12.533vw;border-radius: 0 6.667vw 6.667vw 0;background-color: #E4E4E4;
                                                                                                    margin-left: 2px;display: flex;justify-content: flex-end;align-items: center;">
                            <span style="color: #959595;font-weight: bold;margin-left: 8px;">{{ dlikNum }}</span>
                            <img src="../assets/imgs/uploads/dislike.png" alt=""
                                style="width: 6.4vw;height: 6.4vw;margin-left: 3px;margin-right: 5.067vw;">
                        </div>
                    </div>
                    <div style="font-size: 2.8vw;font-weight: bold;margin-left: 2px;">
                        <p>Press the like/dislike button</p>
                        <p>Let us know your view </p>
                    </div>
                </div>
                <div style="margin-top: 10.667vw;">
                    <div style="margin-bottom: 5.333vw;" v-for="(item, index) in messages" :key="index">
                        <ul style="list-style: disc;color: #333;">
                            <li>{{ item }}</li>
                        </ul>
                    </div>
                </div>
                <el-divider></el-divider>
                <div style="margin-top: 8vw;font-size: 4.533vw;font-weight: bold;color: #000;">Specification</div>
                <div style="font-size: 3.467vw;color: #959595;">
                    <div class="FAttributes">
                        <p class="Attributes">Item No</p>{{ productSkuInfo.productNo }}
                    </div>
                    <div class="FAttributes">
                        <p class="Attributes">Materials</p>{{ productSkuInfo.materialQuality }}
                    </div>
                    <div class="FAttributes">
                        <p class="Attributes">Size</p>{{ productSkuInfo.size }}
                    </div>
                    <div class="FAttributes">
                        <p class="Attributes">Type</p>{{ productSkuInfo.categoryName }}
                    </div>
                    <div class="FAttributes">
                        <p class="Attributes">Batteries</p>{{ productSkuInfo.battery === null ||
                            productSkuInfo.battery === '' ? 'Not Contained' : productSkuInfo.battery }}
                    </div>
                    <div class="FAttributes">
                        <p class="Attributes">Contain</p>
                        <span>
                            {{ productSkuInfo.isCatnip === 1 && productSkuInfo.isMovement === 1 ? 'No' : '' }}
                            {{ productSkuInfo.isCatnip === 1 ? '' : 'Catnip Bag' }}
                            {{ productSkuInfo.isCatnip === 0 && productSkuInfo.isMovement === 0 ? '/' : '' }}
                            {{ productSkuInfo.isMovement === 1 ? '' : 'Electronic movement' }}
                        </span>
                    </div>
                </div>
                <div style="margin-top: 8vw;font-size: 4.533vw;font-weight: bold;color: #000;">Package Info</div>
                <div style="font-size: 3.467vw;color: #959595;margin-bottom: 10.667vw;">
                    <div class="FAttributes">
                        <p class="Attributes">Dimensions</p>{{ productSkuInfo.boxSize }}
                    </div>
                    <div class="FAttributes">
                        <p class="Attributes">Weight</p>{{ productSkuInfo.heft }}
                    </div>
                </div>
                <el-divider></el-divider>
                <div style="margin-top: 8vw;font-size: 4.533vw;font-weight: bold;color: #000;">Product Details</div>
                <div class="backstage"
                    v-html="productDetail.spuInfos && productDetail.spuInfos.length > 0 ? productDetail.spuInfos[0] : ''">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { saveAs } from 'file-saver';
export default {
    metaInfo() {
        return {
            meta: [
                {
                    name: 'keywords',
                    content: this.brand + ',' + this.spuName,
                }
            ]
        }
    },
    data() {
        return {
            unit: 0,
            radio: '',
            dis: false, // 控制“加入购物车按钮是否可用”
            spuId: "", // 商品id
            productDetail: "",
            productSkuInfo: "",
            options: '', // 商品详细信息
            models: [],
            skus: '',
            messages: [],
            images: [],
            selectedIndex1: 0,
            selectedIndex: 0,
            stus: '',
            num: 0,
            isLcl: '',
            amount: 0,
            skuId: 0,
            stockNum: 0,
            isClick: false,
            isClick1: false,
            showPageA: false,
            showPageB: false,
            showPageC: false,
            timer: null,
            brand: '',
            spuName: '',
            topStyle: {
                transform: ""
            },
            r_img: {
            },
            topShow: false,
            rShow: false,
            normalSrc1: require('../assets/imgs/uploads/Group 607.png'),
            hoverSrc1: require('../assets/imgs/uploads/Group 605.png'),
            normalSrc2: require('../assets/imgs/uploads/Group 608.png'),
            hoverSrc2: require('../assets/imgs/uploads/Group 606.png'),
            currentImage1: require('../assets/imgs/uploads/Group 607.png'),
            currentImage2: require('../assets/imgs/uploads/Group 608.png'),
            likeStatus: '0',
            likNum: 0,
            dlikNum: 0,
        };
    },
    // 通过路由获取商品id
    activated() {
        if (this.$route.query.spuId != undefined) {
            this.spuId = this.$route.query.spuId;
        }
        // 设置计时器，在页面加载后开始计时
        this.timer = setTimeout(() => {
            this.recordVisit();
        }, 30000); // 30秒后执行记录
    },
    watch: {
        // 监听商品id的变化，请求后端获取商品数据
        spuId: function (val) {
            this.getDetails(val);
        }
    },
    destroyed() {
        // 清除计时器，在组件销毁时清除计时器，以防止内存泄漏
        clearTimeout(this.timer);
    },
    methods: {
        ...mapActions(["unshiftShoppingCart", "addShoppingCartNum", "setShoppingCart"]),
        // 获取商品详细信息
        getDetails() {
            this.images = []
            this.messages = []
            this.models = []
            this.skus = ''
            this.num = 0
            this.amount = 0
            this.skuId = 0
            this.stockNum = 0
            this.brand = ''
            this.$axios
                .post("/api/mall/spu/detail/",
                    {
                        spuId: this.spuId,
                        memberId: this.$store.getters.getUser.id,
                    }).then(res => {
                        this.productDetail = res.data.data
                        // this.productDetail.spuInfos[0] = this.productDetail.spuInfos[0].replace("<img ","<img class=\"aaa\"")
                        this.brand = this.productDetail.brand
                        this.spuName = this.productDetail.spuName
                        this.images = this.productDetail.skus[0].skuImages
                        this.productSkuInfo = this.productDetail.skus[0].sku
                        this.messages = this.productDetail.descriptions;
                        this.skus = this.productDetail.skus
                        this.models = this.productDetail.skus.map(obj => obj.imgUrl)
                        this.stus = this.skus[0].sku.status
                        this.unit = this.skus[0].sku.price
                        this.num = this.skus[0].sku.memberNum
                        this.isLcl = this.skus[0].sku.isLcl
                        this.amount = this.skus[0].sku.amount
                        this.skuId = this.skus[0].sku.id
                        this.stockNum = this.skus[0].sku.stockNum
                        var data = this.productDetail.skus;
                        if (this.productDetail.spuVideo) {
                            for (let index = 0; index < data.length; index++) {
                                data[index].skuImages.push(this.productDetail.spuVideo)
                            }
                        }
                        this.getLikes()
                    })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        goBack() {
            this.$router.go(-1)
        },

        selectOption(index) {
            this.selectedIndex = index;
            const selectedSku = this.productDetail.skus[index]
            const imagesList = selectedSku.skuImages
            if (selectedSku.skuImages && selectedSku.skuImages.length > 0) {
                this.images = imagesList
            }
            this.stus = selectedSku.sku.status
            this.unit = selectedSku.sku.price
            this.num = selectedSku.sku.memberNum
            this.isLcl = selectedSku.sku.isLcl
            this.amount = selectedSku.sku.amount
            this.skuId = selectedSku.sku.id
            this.stockNum = selectedSku.sku.stockNum
            this.productSkuInfo = selectedSku.sku
            this.getLikes()
        },
        showLargeImage(index) {
            this.selectedIndex1 = index;
        },
        addCart() {
            this.isClick = true;
            setTimeout(() => {
                this.isClick = false;
            }, 2000);
            this.$axios
                .post("/api/mall/cart/updateNum", {
                    memberId: this.$store.getters.getUser.id,
                    skuId: this.skuId,
                    num: this.num
                }).then(res => {
                    if (res.data.code === 200) {
                        this.$axios
                            .post("/api/mall/cart/" + this.$store.getters.getUser.id)
                            .then(res => {
                                if (res.data.code === 200) {
                                    // 001 为成功, 更新vuex购物车状态
                                    this.$message({
                                        showClose: true,
                                        message: 'Successfully added!',
                                        type: 'success'
                                    });
                                    this.setShoppingCart(res.data.data);
                                    this.$set(this.productDetail.skus[this.selectedIndex].sku, 'memberNum', this.num)
                                } else {
                                    // 提示失败信息
                                    this.notifyError(res.data.message);
                                }
                            })
                            .catch(err => {
                                return Promise.reject(err);
                            });
                    }
                })
        },
        getLabelForStatus(status) {
            switch (status) {
                case 0:
                    return this.$t('list.instock');
                case 1:
                    return this.$t('list.production');
                case 2:
                    return this.$t('list.ordertogether');
                default:
                    return 'unknown';
            }
        },
        //下载zip
        downLoads() {
            this.isClick1 = true;
            setTimeout(() => {
                this.isClick1 = false;
            }, 10000);
            this.$axios
                .get("/api/mall/spu/detailZip/" + this.spuId,
                    {
                        responseType: "arraybuffer",
                        headers: { 'content-Type': 'application/json; application/octet-stream' }
                    })
                .then((response) => {
                    this.saveFile(response.data);
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        saveFile(data) {
            const blob = new Blob([data], { type: 'application/zip' }); // 创建一个二进制 Blob
            const fileName = 'downloadedFile.zip'; // 指定下载文件的名称

            saveAs(blob, fileName); // 使用 FileSaver.js 保存文件
        },
        recordVisit() {
            // 记录用户访问信息，可以发送网络请求或者调用其他逻辑
            this.$axios
                .post("/api/mall/log/save",
                    {
                        userId: this.$store.getters.getUser.id ? this.$store.getters.getUser.id : '',
                        userName: this.$store.getters.getUser.nickName ? this.$store.getters.getUser.nickName : '',
                        brand: this.brand,
                        spuId: this.spuId,
                        spuName: this.spuName
                    })
        },
        formatF(value) {
            let value1 = Math.round(parseFloat(value) * 100) / 100;
            let s = value.toString().split(".");
            if (s.length == 1) {
                value1 = value.toString() + ".00";
                return value1;
            }
            if (s.length > 1) {
                if (s[1].length < 2) {
                    value1 = value.toString() + "0";
                }
                return value1;
            }
        },
        fileSubstr(str) {
            if (str) {
                let index = str.lastIndexOf(".");
                return str.substr(index + 1, str.length)
            }

        },
        getLikes() {
            this.$axios
                .post("/api/mall/likes/getLikes", {
                    spuId: this.spuId,
                    userId: this.$store.getters.getUser.id,
                    skuId: this.skuId,
                })
                .then(res => {
                    if (res.data.data) {
                        this.likeStatus = res.data.data.status;
                        this.likNum = res.data.data.likes
                        this.dlikNum = res.data.data.unLikes
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        likes() {
            this.$axios
                .post("/api/mall/likes/likes", {
                    spuId: this.spuId,
                    userId: this.$store.getters.getUser.id,
                    status: '1',
                    skuId: this.skuId,
                })
                .then(() => {
                    this.likeStatus = '1'
                    this.getLikes()
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        dislikes() {
            this.$axios
                .post("/api/mall/likes/likes", {
                    spuId: this.spuId,
                    userId: this.$store.getters.getUser.id,
                    status: '2',
                    skuId: this.skuId,
                })
                .then(() => {
                    this.likeStatus = '2'
                    this.getLikes()
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
    },
    computed: {
        selectedImage() {
            if (this.fileSubstr(this.images[this.selectedIndex1]) == "mp4") {
                return "mp4";
            } else {
                return "image";
            }


        },
    },

};
</script>

<style scoped>
::v-deep .el-divider--horizontal {
    margin: 10px 0;
}

::v-deep .el-input__inner:focus {
    border-color: #333;
}

::v-deep .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
    border-color: #B4BAC1;
}

::v-deep .el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
    border-color: #B4BAC1;
}

.detail {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}

#slider-container {
    max-width: 375px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

#slider {
    display: flex;
    transition: transform 0.5s ease-in-out;
}

.large-image-container {
    width: 100vw;
    /* 设置大图片容器的宽度 */
    height: 100vw;
    /* 设置大图片容器的高度 */
    overflow: hidden;
    /* 确保大图片在容器内显示 */
}

.thumbnail-container {
    position: relative;
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-top: 15px;
    height: 80px;
}

.thumbnail-container::-webkit-scrollbar {
    display: none;
}

.active {
    border: 1px solid #CA141D !important;
}

.thumbnail-container img {
    width: 65px;
    /* 设置小图片的宽度 */
    height: 68px;
    /* 设置小图片的高度 */
    margin-right: 9px;
    border-radius: 10px;
    /* 设置小图片之间的间距 */
}

.thumbnail-container div:last-child img {
    margin-right: 0;
}

.smallmp4 {
    border: 1px solid #FFF;
    margin-right: 9px;
    border-radius: 10px;

    width: 66px;
    height: 69px;
    position: relative;
}

.export {
    width: 32vw;
    height: 27px;
    margin: 10px 0 17px;
    border: 1px solid #FFA9A4;
    border-radius: 5px;
    background-color: #FFE7E5;
    color: #CA141D;
    font-size: 13px;
}

.checktab {
    display: flex;
    margin-top: 23px;
    margin-bottom: 15px;
    overflow-x: scroll;
    overflow-y: hidden;
    height: 80px;
}

.checktab::-webkit-scrollbar {
    display: none;
}

.opn {
    width: 75px;
    height: 75px;
    margin-right: 15px;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.selected {
    border-color: #CA141D !important;
}

.status {
    width: 54px;
    height: 19px;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 9px;
    font-weight: bold;
    border: 1px solid #333;
    border-radius: 14px;
}

.btn {
    width: 317px;
    height: 47px;
    margin-top: 31px;
    background-color: #CA141D;
    border: 1px solid #CA141D;
    color: #FFF;
    font-size: 21px;
    font-weight: bold;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.FAttributes {
    display: flex;
    margin-top: 23px;
}

.Attributes {
    color: #545454;
    width: 16.8vw;
    margin-right: 35px;
}

.backstage {
    margin: 17px auto 53px;
}

::v-deep .backstage img {
    width: 317px;
}
</style>